import styles from './JobMail.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { Button, EmailField } from 'seek-style-guide/react';
import { jobMail, emailChange, states } from 'store/saveSearch/saveSearch';
import { trackConversion } from 'store/experiments/experiments';
import ExternalLink from 'ExternalLink/ExternalLink';

const { SAVED, ERROR, SAVING } = states;

const mapStateToProps = ({ search, results, saveSearch }) => ({
  query: search.query,
  location: results.location,
  status: saveSearch.status,
  errorMessage: saveSearch.errorMessage
});

const mapDispatchToProps = dispatch => ({
  createHandler: ({ query, location, emailAddress }) => {
    dispatch(jobMail({ query, location, emailAddress }));
    dispatch(trackConversion('a1080b1c-e7b9-4f10-9a61-aaa32fdedcda'));
  },
  changeHandler: () => dispatch(emailChange())
});

@connect(mapStateToProps, mapDispatchToProps)
export default class JobMail extends Component {

  static propTypes = {
    query: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    status: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    createHandler: PropTypes.func.isRequired,
    changeHandler: PropTypes.func.isRequired
  };

  constructor() {
    super();

    this.jobMailClick = this.jobMailClick.bind(this);
    this.storeEmailFieldReference = this.storeEmailFieldReference.bind(this);
  }

  storeEmailFieldReference(emailField) {
    if (emailField !== null) {
      this.emailField = emailField.input;
    }
  }

  jobMailClick(ev) {
    ev.preventDefault();
    const { createHandler, query, location } = this.props;
    const emailAddress = this.emailField.value;
    createHandler({ query, location, emailAddress });
  }

  renderForm() {
    const { status, errorMessage, changeHandler } = this.props;

    const isSaving = status === SAVING;
    const isError = status === ERROR;
    const inputProps = {
      required: true,
      readOnly: isSaving,
      placeholder: 'Enter your email',
      title: 'Please enter your email',
      'data-hj-masked': true,
      'data-automation': 'jobmail-email'
    };

    if (isError) {
      /* Add onChange handler only when there has been an error */
      inputProps.onChange = changeHandler;
    }

    return (
      <form data-automation="jobmail-create" className={styles.form} onSubmit={this.jobMailClick}>
        <p className={styles.privacy}>
          {'You can cancel emails at any time. By clicking "email me" you agree to '}
          <ExternalLink
            className={styles.privacyLink}
            analytics="jobmail:privacy"
            href="/privacy">
            {'SEEK\'s Privacy ​Statement'}
          </ExternalLink>
        </p>
        <div className={styles.inputField}>
          <EmailField
            className={styles.email}
            inputProps={inputProps}
            invalid={isError}
            message={errorMessage}
            messageProps={{
              'data-automation': 'jobmail-invalid-message'
            }}
            ref={this.storeEmailFieldReference}
          />
          <Button
            color="blue"
            loading={isSaving}
            type="submit"
            className={styles.button}
            data-automation="jobmail-submit">
            {isSaving ? 'Saving' : 'Create Alert'}
          </Button>
        </div>
      </form>
    );
  }

  renderSuccess() {
    return (
      <div
        className={styles.message}
        data-automation="jobmail-success-message">
        <p className={styles.thankYou}>Alert created</p>
        <p className={styles.createdMessage}>
          { 'We\'ll send new jobs to ' }
          <span data-hj-masked={true}>{ this.emailField.value }</span>
        </p>
      </div>
    );
  }

  render() {
    const { status } = this.props;

    return status === SAVED ? this.renderSuccess() : this.renderForm();
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SavePanel/components/JobMailNew/JobMail.js
 **/